import { render } from "./wLoadingCard.vue?vue&type=template&id=08f19ca2&ts=true"
import script from "./wLoadingCard.vue?vue&type=script&lang=ts"
export * from "./wLoadingCard.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__